<template>
    <div>
        <!-- Modale ajout / édition -->
        <modal :name="id ? id : 'modal-add-chantier'" width="90%" height="auto" :scrollable="true" :adaptive="true" @closed="selectedTypeIntervention = null;">
            <div class="flex items-center justify-end pb-4 text-2xl p-6">
                <button @click="$modal.hide(id ? id : 'modal-add-chantier');">
                    <i class="fas fa-times text-red-500"></i>
                </button>
            </div>
            <div class="px-6 pb-6 font-[system-ui] bg-white min-h-screen max-h-[90vh] overflow-y-auto">
                <chantier-init @slots-created="onSlotsCreated" />
            </div>
        </modal>
    </div>
</template>

<script>
import ChantierInit from './../../Chantier/Components/ChantierInit.vue'
export default {
    components: {
        ChantierInit
    },
    props: {
        id: { type: String, default: null }
    },
    methods: {
        onSlotsCreated() {
            this.$modal.hide(this.id ? this.id : 'modal-add-chantier')
            this.$emit('slots-created')
        }
    },
}
</script>

<style>

</style>